module.exports = __webpack_public_path__ + "img/r.1e780a24.png";